/**
 * @generated SignedSource<<63c850eda45dea688ef62aa5f3667e50>>
 * @relayHash ef5a34541255334ddc883e1a2272dec7
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c3b3767495fee09fc2decb883f3881cf1346f2fb769af4bb18e55c79a82a93cb

import { ConcreteRequest } from 'relay-runtime';
export type explorerPageQuery$variables = {
  account: string;
  branch: string;
  graph: string;
};
export type explorerPageQuery$data = {
  readonly branch: {
    readonly endpointConfig: {
      readonly url: string;
    } | null | undefined;
    readonly federatedSchema: string | null | undefined;
  } | null | undefined;
};
export type explorerPageQuery = {
  response: explorerPageQuery$data;
  variables: explorerPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "account"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "branch"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "graph"
},
v3 = [
  {
    "kind": "Variable",
    "name": "accountSlug",
    "variableName": "account"
  },
  {
    "kind": "Variable",
    "name": "graphSlug",
    "variableName": "graph"
  },
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "branch"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "federatedSchema",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "EndpointConfig",
  "kind": "LinkedField",
  "name": "endpointConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "explorerPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Branch",
        "kind": "LinkedField",
        "name": "branch",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "explorerPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Branch",
        "kind": "LinkedField",
        "name": "branch",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ef5a34541255334ddc883e1a2272dec7",
    "id": "c3b3767495fee09fc2decb883f3881cf1346f2fb769af4bb18e55c79a82a93cb",
    "metadata": {},
    "name": "explorerPageQuery",
    "operationKind": "query",
    "text": "query explorerPageQuery(\n  $account: String!\n  $graph: String!\n  $branch: String!\n) {\n  branch(accountSlug: $account, graphSlug: $graph, name: $branch) {\n    federatedSchema\n    endpointConfig {\n      url\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ee9185c65d9bf8ef067fead693cf405f";

export default node;
